import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import AuditorDashboard from './pages/AuditorDashboard';
import SponsorDashboard from './pages/SponsorDashboard';

function PrivateRoute({ children, role }) {
  const { user, loading } = useAuth();
  
  if (loading) return <div>Chargement...</div>;
  if (!user) return <Navigate to="/auth" />;
  if (role && user.role !== role) return <Navigate to="/" />;
  
  return children;
}

function App() {
  return (
    <Router>
      <LangProvider>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/auditor" element={
              <PrivateRoute role="auditor">
                <AuditorDashboard />
              </PrivateRoute>
            } />
            <Route path="/sponsor" element={
              <PrivateRoute role="sponsor">
                <SponsorDashboard />
              </PrivateRoute>
            } />
          </Routes>
        </AuthProvider>
      </LangProvider>
    </Router>
  );
}

export default App;
